module.exports = __webpack_public_path__ + "assets/Unrest-white.202573ae.svg";